module.exports = __webpack_public_path__ + "img/stakewise.24a5b832.svg";